import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@core/stores/auth.store';

/**
 * Route guard — ports `core/guards/auth.guard.ts`.
 *
 * Two differences from the Angular guard, both deliberate:
 *
 * 1. No `isPlatformBrowser` check. The Angular guard returned `false` on the server,
 *    which combined with `app.routes.server.ts`'s prerender-everything to make SSR of
 *    protected routes impossible. We ship a client-only SPA, so the branch is gone.
 *
 * 2. `returnUrl` includes the query string, which `state.url` did but the login page's
 *    `window.location.search` read could mangle. Consumed in `LoginPage`, which
 *    validates it starts with `/` before navigating — an open-redirect guard the
 *    Angular `getReturnUrl()` did not have.
 */
export function RequireAuth() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    const returnUrl = `${location.pathname}${location.search}`;
    const suffix = returnUrl && returnUrl !== '/' ? `?returnUrl=${encodeURIComponent(returnUrl)}` : '';
    return <Navigate to={`/login${suffix}`} replace />;
  }

  return <Outlet />;
}
